import { useErpName } from '@/api/org/config/useErpName';

/**
 * The marker on a note that comes from the ERP; read-only in Gently. Shows
 * the ERP's own name (e.g. "Famous"), which is what users know it by.
 */
export function ErpChip() {
  const erpName = useErpName();
  return (
    <span className="shrink-0 rounded bg-stone-200 px-1 text-[9px] font-semibold tracking-wide text-stone-600 uppercase">
      {erpName}
    </span>
  );
}
